<template>
  <el-dialog
    title="订单量统计"
    :visible.sync="dialogVisible"
    v-model="dialogVisible"
    :close-on-click-modal="false"
    custom-class="minheight"
    width="70%"
  >
    <!--工具条-->
    <div class="toolbarWrapper">
      <el-form :inline="true" size="small" class="comptoolbar">
        <el-form-item>
          <el-date-picker
            v-model="startDate"
            type="date"
            placeholder="开始时间"
            value-format="yyyy-MM-dd"
            style="width: 150px"
            :clearable="false"
            :editable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="endDate"
            type="date"
            placeholder="结束时间"
            value-format="yyyy-MM-dd"
            style="width: 150px"
            :clearable="false"
            :editable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList()" :loading="listLoading"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item> 订单量：<span class="text_red">{{ (Total/datedifference(startDate,endDate)).toFixed(2) }}/{{ Total }} </span></el-form-item>
      </el-form>
    </div>
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%"
    >
      <el-table-column :label="$t('Name')">
        <template slot-scope="scope">
          {{ field(scope.row.Name) }}
        </template>
      </el-table-column>
      <el-table-column prop="Number" label="数量"></el-table-column>
    </el-table>
  </el-dialog>
</template>

<style>
.echarts {
  width: 100%;
}
</style>
<script>
import util from "util/date";
import { getOrderNumberTotal } from "@/api/api";
import { getButtonList } from "@/promissionRouter";
export default {
  data() {
    return {
      list: [],
      listLoading: false,
      dialogVisible: false,
      selectPara: {},
      shopName: "",
      startDate: "",
      endDate: "",
      Total: 0,
    };
  },
  methods: {
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy/MM/dd hh:mm");
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.Func].apply(this, item);
    },
    //获取列表
    getList() {
      this.listLoading = true;
      let para = { startDate: this.startDate, endDate: this.endDate };
      getOrderNumberTotal(para).then((res) => {
        this.list = res.data.response.ItemList;
        this.Total = res.data.response.Total;
        this.listLoading = false;
      });
    },
    loadData(startDate, endDate) {
      this.startDate = startDate;
      this.endDate = endDate;
      this.getList();
      this.dialogVisible = true;
    },
    datedifference(sDate1, sDate2) {
      //sDate1和sDate2是2006-12-18格式
      var dateSpan, tempDate, iDays;
      sDate1 = Date.parse(sDate1);
      sDate2 = Date.parse(sDate2);
      dateSpan = sDate2 - sDate1;
      dateSpan = Math.abs(dateSpan);
      iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
      return iDays+1;
    },
  },
};
</script>
